import './index.scss'

import { CustomerServiceOutlined, MessageOutlined, ShoppingCartOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { getNotificationUnreadCountApi } from '@/network/api/notification'
import { openCustomerServiceDialog } from '@/shared/customerService'
import { useMallCountStore } from '@/store/mallCount'
import { useUserStore } from '@/store/user'

/** 全局右侧快捷栏：消息 / 客服 / 购物车 */
function GlobalQuickDock() {
  const navigate = useNavigate()
  const location = useLocation()
  const [mobileExpanded, setMobileExpanded] = useState(false)
  const token = useUserStore((state) => state.token)
  const { cartCountInfo, getCartCountInfo } = useMallCountStore((state) => state)
  const cartCount = cartCountInfo.cart_count_total || 0
  const [messageUnreadCount, setMessageUnreadCount] = useState(0)

  useEffect(() => {
    if (token) {
      getCartCountInfo()
    }
  }, [getCartCountInfo, token])

  // 站内信未读徽标：路由切换时刷新，保证从消息中心返回后口径一致
  useEffect(() => {
    if (!token) {
      setMessageUnreadCount(0)
      return
    }
    getNotificationUnreadCountApi()
      .then((response) => setMessageUnreadCount(response.data.count || 0))
      .catch(() => undefined)
  }, [token, location.pathname])

  useEffect(() => {
    setMobileExpanded(false)
  }, [location.pathname])

  const handleMessage = () => {
    navigate('/messagecenter')
    setMobileExpanded(false)
  }

  const handleCart = () => {
    navigate('/shoppingcart')
    setMobileExpanded(false)
  }

  const handleKefu = () => {
    openCustomerServiceDialog()
    setMobileExpanded(false)
  }

  return (
    <aside
      className={`global-quick-dock ${mobileExpanded ? 'global-quick-dock--expanded' : ''}`}
      aria-label="快捷工具栏"
    >
      <button
        type="button"
        className="global-quick-dock-mobile-trigger"
        aria-expanded={mobileExpanded}
        aria-controls="global-quick-dock-actions"
        onClick={() => setMobileExpanded((expanded) => !expanded)}
      >
        {mobileExpanded ? '收起' : '快捷'}
      </button>
      <div id="global-quick-dock-actions" className="global-quick-dock-actions" role="group" aria-label="快捷操作">
        <button type="button" className="global-quick-dock-item" onClick={handleMessage}>
          <span className="global-quick-dock-icon">
            <MessageOutlined />
            {token && messageUnreadCount > 0 ? (
              <span className="global-quick-dock-badge">{messageUnreadCount > 99 ? '99+' : messageUnreadCount}</span>
            ) : null}
          </span>
          <span className="global-quick-dock-label">消息</span>
        </button>
        <button type="button" className="global-quick-dock-item" onClick={handleKefu}>
          <span className="global-quick-dock-icon">
            <CustomerServiceOutlined />
          </span>
          <span className="global-quick-dock-label">客服</span>
        </button>
        <button type="button" className="global-quick-dock-item" onClick={handleCart}>
          <span className="global-quick-dock-icon">
            <ShoppingCartOutlined />
            {token && cartCount > 0 ? (
              <span className="global-quick-dock-badge">{cartCount > 99 ? '99+' : cartCount}</span>
            ) : null}
          </span>
          <span className="global-quick-dock-label">购物车</span>
        </button>
      </div>
    </aside>
  )
}

export default GlobalQuickDock

export const GLOBAL_QUICK_DOCK_HIDDEN_PREFIXES = ['/login', '/ai/imageTo3d', '/ai/pricing', '/ai/member'] as const

export function shouldShowGlobalQuickDock(pathname: string) {
  return !GLOBAL_QUICK_DOCK_HIDDEN_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
}
